/* eslint-disable no-nested-ternary */
/* eslint-disable no-template-curly-in-string */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable no-use-before-define */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable consistent-return */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-restricted-syntax */
/* eslint-disable eqeqeq */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-alert */
/* eslint-disable no-param-reassign */
/* eslint-disable import/no-cycle */
import { DialogUtility, DialogComponent } from '@syncfusion/ej2-react-popups';
import { DatePickerComponent } from '@syncfusion/ej2-react-calendars';
import { ButtonComponent, CheckBoxComponent, RadioButtonComponent } from '@syncfusion/ej2-react-buttons';
import React, { useState, useEffect, useRef } from 'react';
import { DropDownListComponent, MultiSelectComponent, CheckBoxSelection, Inject } from '@syncfusion/ej2-react-dropdowns';

import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { useNavigate } from 'react-router-dom';

import { DataManager, Query } from '@syncfusion/ej2-data';
import { useStateContext } from '../contexts/ContextProvider';
import { langData } from '../data/dummy';
import '../pages/Zackat.css';

const AssociateContent = ({ associate, orgData, closeDialog }) => {
  let usr = localStorage.getItem('user');
  let selectedOrg = localStorage.getItem('organization');
  const navigate = useNavigate();
  if (!usr || !selectedOrg) {
    // Redirect
    navigate('/login?landing=associatescontrolcenter');
    return <p>Please login... </p>;
  }
  usr = JSON.parse(usr);
  selectedOrg = JSON.parse(selectedOrg);
  const {
    setPatientId,
  } = useStateContext();

  const [associateid, setAssociateId] = useState(associate._id);
  const { REACT_APP_API_ENDPOINT } = process.env;
  const [riskColor, setRiskColor] = useState('e-outline');
  const [envColor, setEnvColor] = useState('e-outline');
  const [hypoColor, setHypoColor] = useState('transparent');
  const [baseColor, setBaseColor] = useState('transparent');
  const [moderateColor, setModerateColor] = useState('transparent');
  const [elevatedColor, setElevatedColor] = useState('transparent');
  const [severeColor, setSevereColor] = useState('transparent');
  const [selName, setName] = useState(associate.name);
  const [selVitals, setVitals] = useState('');
  const [selDevice, setDevice] = useState(associate.device);
  const [selMSN, setMSN] = useState('');
  const [selOrganization, setOrganization] = useState(associate.organizationid);
  const [selLanguage, setLanguage] = useState(associate.language);
  const [selEngineering, setEngineering] = useState(associate.engineering);
  const [selEmployeeImage, setEmployeeImage] = useState(associate.employeeImage);
  const [selMobile, setMobile] = useState(associate.mobile);
  const [selEmail, setEmail] = useState(associate.email);
  const [selRisk, setRisk] = useState(associate.risk);
  const [selEnvironment, setEnvironment] = useState(associate.environment);
  const [selAddress, setAddress] = useState(associate.address);
  const [selAddress1, setAddress1] = useState(associate.address1);
  const [selCity, setCity] = useState(associate.city);
  const [selState, setState] = useState(associate.state);
  const [selZip, setZip] = useState(associate.zip);
  const [selDob, setDob] = useState(associate.dob);
  const [selAge, setAge] = useState('');
  const [smsOptin, setSMSOptin] = useState(associate.smsOptin);
  const [emailOptin, setEmailOptin] = useState(associate.emailOptin);
  const [gender, setGender] = useState(associate.gender);
  const [mgrData, setMgrData] = useState([]);
  const [taskData, setJobTasks] = useState([]);
  const [selJobTask, setJobTask] = useState(associate.jobtask);
  const [managers, setManagers] = useState(associate.managers);
  const [selRefresh, setRefresh] = useState(associate.refresh);
  const [bundleData, setBundleData] = useState([]);

  const [selBundle, setBundle] = useState(associate.alertBundle);
  const [mymsns, setMyMSN] = useState([]);

  const changeMSN = (e) => {
    setDevice(e.value);
    const element = document.getElementById('iccid');
    if (element) {
      element.value = e.value;
    }
  };
  const {
    boss,
  } = useStateContext();

  const multilineAttributes = {
    rows: 4, // Sets the initial visible number of lines to 4
  };

  function handleChange(e) {
    e.preventDefault();
    const filedata = new FormData();
    const imagedata = e.target.files[0];
    filedata.append('userfile', imagedata);
    if (associateid !== '' && associateid !== 'add_associate') {
      filedata.append('_id', associateid);
      filedata.append('fileName', e.target.files[0].name);
      setAssociateId('');
      setPatientId('');
    } else {
      return;
    }
    fetch(`${REACT_APP_API_ENDPOINT}/fileup`, {
      method: 'POST',
      headers: {
        Authorization: `JWTToken ${usr.token}`,
      },
      body: filedata,
    })
      .then((response) => response.json())
      .then((responseJson) => {
        // window.location.reload();
        // setReload(!reload);
        e.target.value = null;
        setTimeout(setAssociateId(e.target.id), 2000);
        setPatientId(e.target.id);
      })
      .catch((error) => {
        DialogUtility.alert('An error has occured during Insert!');
      });
  }
  useEffect(() => {
    let vitals = '';
    if (associate.temperature && associate.temperature.reading) {
      vitals = `Temperature ${associate.temperature.reading} °F`;
      if (associate.baseline && associate.baseline.temperature && associate.baseline.temperature.nominal) {
        vitals += `\tBaseline ${associate.baseline.temperature.nominal.toFixed(1)} °F\r\n`;
      } else {
        vitals += '\tBaseline °F\r\n';
      }
    }
    if (associate.heartrate && associate.heartrate.reading) {
      vitals += `Heartrate ${associate.heartrate.reading} bpm`;
      if (associate.baseline && associate.baseline.heartrate && associate.baseline.heartrate.nominal) {
        vitals += `\tBaseline ${associate.baseline.heartrate.nominal.toFixed(1)} bpm\r\n`;
      } else {
        vitals += '\tBaseline bpm\r\n';
      }
    }
    if (associate.oxygen && associate.oxygen.reading) {
      vitals += `Oxygen ${associate.oxygen.reading} %`;
      if (associate.baseline && associate.baseline.oxygen && associate.baseline.oxygen.nominal) {
        vitals += `\tBaseline ${associate.baseline.oxygen.nominal.toFixed(1)} %\r\n`;
      } else {
        vitals += '\tBaseline %\r\n';
      }
    }
    if (associate.hydration && associate.hydration.reading) {
      vitals += `Hydration ${associate.hydration.reading} %`;
      if (associate.baseline && associate.baseline.hydration && associate.baseline.hydration.nominal) {
        vitals += `\tBaseline ${associate.baseline.hydration.nominal.toFixed(1)} %\r\n`;
      } else {
        vitals += '\tBaseline %\r\n';
      }
    }
    setVitals(vitals);
  }, []);
  useEffect(() => {
    setBaseColor('cyan');
    if (associate) {
      setRiskColor('e-outline');
      setEnvColor('e-outline');
      if (Number(associate.risk) < 0) {
        setRiskColor('e-outline e-info');
        setHypoColor('cyan');
        setBaseColor('transparent');
        setModerateColor('transparent');
        setElevatedColor('transparent');
        setSevereColor('transparent');
      } else if (associate.risk === '' || Number(associate.risk) < 25) {
        setRiskColor('e-outline e-success');
        setHypoColor('transparent');
        setBaseColor('cyan');
        setModerateColor('transparent');
        setElevatedColor('transparent');
        setSevereColor('transparent');
      } else if (Number(associate.risk) < 50) {
        setRiskColor('e-outline e-info');
        setHypoColor('transparent');
        setBaseColor('transparent');
        setModerateColor('cyan');
        setElevatedColor('transparent');
        setSevereColor('transparent');
      } else if (Number(associate.risk) < 80) {
        setRiskColor('e-outline e-warning');
        setHypoColor('transparent');
        setBaseColor('transparent');
        setModerateColor('transparent');
        setElevatedColor('cyan');
        setSevereColor('transparent');
      } else if (Number(associate.risk) >= 80) {
        setRiskColor('e-outline e-error');
        setHypoColor('transparent');
        setBaseColor('transparent');
        setModerateColor('transparent');
        setElevatedColor('transparent');
        setSevereColor('cyan');
      }
    } else {
      setRiskColor('e-outline');
    }
  }, []);

  const addProfile = () => {
    const result = orgData.find(({ _id }) => _id === selOrganization);
    const newassociate = {};
    if (!result) {
      DialogUtility.alert('Could not set Organization');
      return;
    }
    newassociate.organizationid = selOrganization;
    newassociate.organization = result.title;
    const lresult = langData.find(({ id }) => id === selLanguage);
    newassociate.language = lresult.id;
    newassociate.name = selName;
    newassociate.device = selDevice;
    newassociate.mobile = selMobile;
    newassociate.email = selEmail;
    newassociate.address = selAddress;
    newassociate.address1 = selAddress1;
    newassociate.city = selCity;
    newassociate.state = selState;
    newassociate.zip = selZip;
    newassociate.jobtask = selJobTask;
    newassociate.alertBundle = selBundle;
    newassociate.engineering = selEngineering;
    newassociate.refresh = selRefresh.toString();
    newassociate.employeeImage = 'https://monaco.zackat.com/blank.png';
    if (selDob !== '') {
      newassociate.dob = new Date(selDob).toLocaleDateString();
    } else {
      newassociate.dob = '';
    }
    if (gender === 'male') {
      newassociate.gender = 'male';
    } else if (gender === 'female') {
      newassociate.gender = 'female';
    } else {
      newassociate.gender = '';
    }
    if (selName.length === 0) {
      DialogUtility.alert('Please provide a name for the associate');
      return;
    }
    if (selDevice.length > 0 && (selDevice.length < 19 || selDevice.length > 20)) {
      DialogUtility.alert('Please provide a valid device for the associate');
      return;
    }
    if (selEmail.length > 0 && (!selEmail.includes('@') || !selEmail.includes('.'))) {
      DialogUtility.alert('Please provide a valid email for the associate');
      return;
    }
    if (selOrganization.length === 0) {
      DialogUtility.alert('Please select an Organization for the associate!');
      return;
    }
    fetch(`${REACT_APP_API_ENDPOINT}/associates`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(newassociate),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        // The added/edited data will be saved in the Grid
        if (responseJson && responseJson._id) {
          newassociate._id = responseJson._id;
          setAssociateId(newassociate._id);
          setPatientId(newassociate._id);
          localStorage.setItem('currentAssociate', newassociate.name);
        }
        if (responseJson && responseJson.response && responseJson.response !== 'OK') {
          DialogUtility.alert(responseJson.response);
        } else {
          // setCurrentAssociate(selName);
          DialogUtility.alert(`New Associate created ${newassociate.name}`);
          closeDialog();
        }
      })
      .catch((error) => {
        DialogUtility.alert('An error has occured during New Associate Insert!');
        console.error(error.message);
      });
  };

  const saveProfile = (e) => {
    if (selOrganization && associate.organizationid !== selOrganization) {
      const result = orgData.find(({ _id }) => _id === selOrganization);
      if (!result) {
        DialogUtility.alert('Could not set Organization');
        return;
      }
      if (!confirm(`Would you like to move this Associate ${associate.name} from ${associate.organization} to ${result.title}`)) {
        setOrganization(associate.organizationid);
        return;
      }
      associate.organizationid = result._id;
      associate.organization = result.title;
    }
    if (selLanguage && associate.language !== selLanguage) {
      const result = langData.find(({ id }) => id === selLanguage);
      associate.language = result.id;
    }
    associate.jobtask = selJobTask;
    associate.managers = managers;

    if (selName.length === 0) {
      DialogUtility.alert('Please provide a name for the associate');
      return;
    }
    if (selDevice.length > 0 && (selDevice.length < 19 || selDevice.length > 20)) {
      DialogUtility.alert('Please provide a valid device for the associate');
      return;
    }
    if (selEmail.length > 0 && (!selEmail.includes('@') || !selEmail.includes('.'))) {
      DialogUtility.alert('Please provide a valid email for the associate');
      return;
    }

    associate.name = selName;
    associate.device = selDevice;
    associate.mobile = selMobile;
    associate.email = selEmail;
    associate.address = selAddress;
    associate.address1 = selAddress1;
    associate.city = selCity;
    associate.state = selState;
    associate.zip = selZip;
    associate.engineering = selEngineering;
    //    if (selDob && selDob.length > 0 && selDob !== 'Invalid Date' && selDob !== 'undefined') {
    if (selDob) {
      associate.dob = new Date(selDob).toLocaleDateString();
      if (associate.dob === 'Invalid Date') {
        associate.dob = '';
      }
    } else {
      associate.dob = '';
    }
    if (gender === 'male') {
      associate.gender = 'male';
    } else if (gender === 'female') {
      associate.gender = 'female';
    }
    if (associate.organizationid.length === 0) {
      DialogUtility.alert('Please select an Organization for the associate!');
      return;
    }

    associate.alertBundle = selBundle;
    fetch(`${REACT_APP_API_ENDPOINT}/associates`, {
      method: 'UPDATE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(associate),
    })
      .then((response) => response.json())
      .then(() => {
        // The added/edited data will be saved in the Grid
        // The default edit operation is cancelled
        DialogUtility.alert('Profile saved');
        closeDialog();
      })
      .catch((error) => {
        console.error(error);
        DialogUtility.alert('An error has occured during Update!');
      });
  };

  useEffect(() => {
    // limit associates to the overall selection
    if (!selOrganization || selOrganization.length === 0) {
      return;
    }
    usr.organizationid = selOrganization;
    // fetch data
    const bundleFetch = async () => {
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/alerts?${query}&specific=true`;
      try {
        const mydata = await (
          await fetch(url, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `JWTToken ${usr.token}`,
            },
          })
        ).json()
          .catch((err) => {
            console.error('Error parsing JSON:', err);
            return null;
          });
        // set state when the data received
        const mybundles = [{ _id: '', name: 'N/A' }];
        if (mydata && mydata.alerts) {
          const selectedArray = mydata.alerts.map((alert) => ({
            _id: alert._id,
            name: alert.name,
          }));
          mybundles.push(...selectedArray);
        }
        setBundleData(mybundles);
      } catch (error) {
        console.error(error);
      }
    };
    bundleFetch();
  }, [selOrganization]);
  const saveManagers = (e) => {
    setManagers(e.value);
  };

  useEffect(() => {
    if (!selOrganization || selOrganization.length === 0) {
      return;
    }
    usr.organizationid = selOrganization;
    const getJobsData = async () => {
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/organizations?${query}&orgid=${selOrganization}`;
      await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWTToken ${usr.token}`,
        },
      })
        .then((response) => response.json())
        .then((mydata) => {
          let myjobs = [];
          if (mydata && mydata.tasks && mydata.tasks.length > 0) {
            myjobs = mydata.tasks;
          }
          setJobTasks(myjobs);
        })
        .catch((error) => {
          setJobTasks([]);
        });
    };
    getJobsData();
  }, [selName, selOrganization]);
  useEffect(() => {
    const getManagerData = async () => {
      if (!selOrganization || selOrganization.length === 0) {
        return;
      }
      // usr.organizationid = selOrganization;
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/managers?${query}&orgid=${usr.organizationid}`;
      await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWTToken ${usr.token}`,
        },
      })
        .then((response) => response.json())
        .then((mydata) => {
          let mymgr = [];
          if (mydata && mydata.length > 0) {
            mydata.forEach((m) => {
              m.name = `${m.first} ${m.last}`;
            });
            mymgr = mydata;
          }
          setMgrData(mymgr);
        })
        .catch((error) => {
          setMgrData([]);
        });
    };
    getManagerData();
  }, [selOrganization]);

  useEffect(() => {
    // limit associates to the overall selection
    // fetch data
    const invFetch = async () => {
      if (!selOrganization || selOrganization.length === 0) {
        return;
      }
      usr.organizationid = selOrganization;
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/inventory?${query}&specific=true`;
      if (!usr.loggedIn) {
        navigate('/login');
        return;
      }
      setMyMSN([]);
      await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWTToken ${usr.token}`,
        },
      })
        .then((response) => response.json())
        .then((mydata) => {
          // Orig set state when the data received
          const mymsndata = [];
          mymsndata.push({ _id: '', title: 'unassign' });
          if (mydata && mydata.inventory) {
            mydata.inventory.forEach((a) => {
              if (a && a.msn && a.device && a.msn.length > 0 && a.device.length > 0) {
                if (a.device && a.device.length > 0 && (!a.associateid || a.associateid.length === 0)) {
                  mymsndata.push({ _id: a.device, title: a.msn });
                } else if (a.device === associate.device && a.associateid === associate._id) {
                  setMSN(a.msn);
                  mymsndata.push({ _id: a.device, title: a.msn });
                }
              }
            });
          }
          setMyMSN(mymsndata);
        })
        .catch((e) => {
          console.error(e.message);
        });
    };
    invFetch();
  }, [associate, selOrganization]);

  function setDateOfBirth(e) {
    setDob(e.value);
  }
  useEffect(() => {
    const calculateAge = () => {
      if (selDob && selDob !== '') {
        const today = new Date();
        const birthDateObj = new Date(selDob);
        let calculatedAge = today.getFullYear() - birthDateObj.getFullYear();
        const monthDiff = today.getMonth() - birthDateObj.getMonth();

        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDateObj.getDate())) {
          calculatedAge -= 1;
        }
        setAge(calculatedAge);
      } else {
        setAge('');
      }
    };
    calculateAge();
  }, [selDob]);

  const organizations = {
    params: {
      actionComplete: () => false,
      dataSource: new DataManager(orgData),
      fields: { value: '_id', text: 'title' },
      query: new Query(),
    },
  };
  const msns = {
    params: {
      actionComplete: () => false,
      dataSource: new DataManager(mymsns),
      fields: { value: '_id', text: 'title' },
      query: new Query(),
    },
  };

  return (
    <div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white rounded-3xl">
      <table className="biotable" style={{ width: '100%' }}>
        <tbody>
          <tr>
            <th style={{ backgroundColor: hypoColor }}><font color="blue">HYPO</font></th>
            <th style={{ backgroundColor: baseColor }}><font color="green">BASELINE</font></th>
            <th style={{ backgroundColor: moderateColor }}><font color="yellow">MODERATE</font></th>
            <th style={{ backgroundColor: elevatedColor }}><font color="orange">ELEVATED</font></th>
            <th style={{ backgroundColor: severeColor }}><font color="red">SEVERE</font></th>
          </tr>
        </tbody>
      </table>
      {associateid !== 'add_associate' && (
      <div className="control-section accordion-control-section">
        <div className="control Accordion-sample" style={{ margin: '25px 0' }}>
          <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-8">
            <div className="e-input-group">
              <div className="mt-4"> Vitals </div>
            </div>
            <div className="mt-2 e-input-group">
              <TextBoxComponent multiline htmlAttributes={multilineAttributes} value={selVitals} title="vital readings" cssClass={riskColor} readOnly floatLabelType="Never" onChange={() => { }} />
            </div>
          </div>
        </div>
      </div>
      )}
      <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2 mt-6">
        <div className="e-input-group">
          <TextBoxComponent placeholder="Risk" value={selRisk} title="Calculated based on baseline, and vitals readings" disabled cssClass={riskColor} readOnly floatLabelType="Auto" onChange={() => { }} />
          <TextBoxComponent placeholder="Environment" title="Calculated based on climate conditions" value={selEnvironment} disabled cssClass={envColor} readOnly floatLabelType="Auto" onChange={() => { }} />
        </div>
      </div>
      {associateid !== 'add_associate' && (
      <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2">
        <div className="e-input-group">
          <img src={selEmployeeImage} className="w-10 h-10" value={selName} id={associateid} />
          <input type="file" name="userfile" id={associateid} onChange={handleChange} />
        </div>
      </div>
      )}
      <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2 mt-6">
        <div className="e-input-group">
          <TextBoxComponent
            placeholder="Name"
            title="Associate Name"
            value={selName}
            cssClass="e-error e-outline"
            floatLabelType="Auto"
            onChange={(v) => { setName(v.value); }}
          />
          <MultiSelectComponent id="ddlreport" dataSource={mgrData} fields={{ value: '_id', text: 'name' }} cssClass="e-outline" disabled={associateid === 'add_associate'} floatLabelType="Auto" mode="CheckBox" value={managers} onChange={saveManagers} placeholder="Select Manager">
            <Inject services={[CheckBoxSelection]} />
          </MultiSelectComponent>
          <DropDownListComponent
            id="ddljob"
            key={selJobTask || 'job-empty'}
            cssClass="e-outline"
            floatLabelType="Auto"
            dataSource={taskData}
            fields={{ value: 'id', text: 'text' }}
            placeholder="Select Task"
            value={selJobTask}
            onChange={(v) => { setJobTask(v.value); }}
          />
        </div>
      </div>
      <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2 mt-6">
        <div className="e-input-group">
          <TextBoxComponent placeholder="Enter Address" value={selAddress} showClearButton cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setAddress(v.value); }} />
          <TextBoxComponent placeholder="Enter Address cont." value={selAddress1} showClearButton cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setAddress1(v.value); }} />
        </div>
      </div>
      <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2 mt-6">
        <div className="e-input-group">
          <TextBoxComponent placeholder="Enter City" value={selCity} showClearButton cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setCity(v.value); }} />
          <TextBoxComponent placeholder="Enter State" value={selState} showClearButton cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setState(v.value); }} />
          <TextBoxComponent placeholder="Enter Zip" value={selZip} showClearButton cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setZip(v.value); }} />
        </div>
      </div>
      <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2 mt-6">
        <div className="e-input-group">
          <TextBoxComponent placeholder="Mobile" value={selMobile} type="text" showClearButton cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setMobile(v.value); }} />
          <TextBoxComponent placeholder="Email Address" value={selEmail} type="email" showClearButton cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setEmail(v.value); }} />
        </div>
      </div>
      <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2 mt-6">
        <div className="e-input-group">
          <TextBoxComponent
            placeholder="Device"
            id="iccid"
            width={250}
            title="SIM Device Identification"
            showClearButton
            value={selDevice}
            type="text"
            cssClass="e-outline"
            floatLabelType="Auto"
            readonly
            onChange={(v) => { setDevice(v.value); }}
          />
          <DropDownListComponent
            id="ddlelementmsn"
            key={selMSN || 'msn-empty'}
            floatLabelType="Auto"
            cssClass="e-outline"
            width={300}
            dataSource={msns.params.dataSource}
            fields={msns.params.fields}
            placeholder="Select MSN"
            value={selDevice}
            onChange={(v) => { changeMSN(v); }}
          />
        </div>
      </div>

      <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2 mt-6 mb-4">
        <div className="e-input-group">
          <CheckBoxComponent label="SMS OpIin" title="Controlled via mobile App" disabled checked={smsOptin} />
          <CheckBoxComponent label="Email OptIn" title="Controlled via mobile App" disabled checked={emailOptin} />
          {boss && <CheckBoxComponent label="Engineering Use Only" checked={selEngineering} change={(v) => { setEngineering(v.checked); }} />}
          {boss && <TextBoxComponent placeholder="Refresh Rate" floatLabelType="Auto" width={150} title="Refresh Rate" showClearButton value={selRefresh} type="text" cssClass="e-outline" onChange={(v) => { setRefresh(v.value); }} />}
        </div>
      </div>
      <div className="row custom-margin">
        <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 mt-6">
          <div className="e-input-group">
            <DatePickerComponent id="dob" cssClass="e-outline" floatLabelType="Auto" change={setDateOfBirth} onChange={setDateOfBirth} placeholder="Date of Birth M/D/YYYY" value={selDob} />
            <TextBoxComponent placeholder="Age" width={100} title="Calculated from Date of Birth" value={selAge} type="text" disabled cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setAge(v.value); }} />
            <div className="row">
              <RadioButtonComponent label="Male" name="gender" value="male" checked={gender === 'male'} onChange={(v) => { setGender(v.value); }} />
            </div>
            <div className="row">
              <RadioButtonComponent label="Female" name="gender" value="female" checked={gender === 'female'} onChange={(v) => { setGender(v.value); }} />
            </div>
          </div>
        </div>
      </div>
      <div className="row custom-margin">
        <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6">
          <div className="e-input-group mt-6">
            <DropDownListComponent
              id="ddlelement"
              floatLabelType="Auto"
              cssClass="e-outline"
              dataSource={organizations.params.dataSource}
              fields={organizations.params.fields}
              placeholder="Select Organization"
            // enabled={false} // Disables the entire component
              value={selOrganization}
              change={(v) => { setOrganization(v.value); }}
            />
            <DropDownListComponent
              id="ddllanguage"
              floatLabelType="Auto"
              cssClass="e-outline"
              dataSource={langData}
              fields={{ value: 'id', text: 'value' }}
              placeholder="Select Language"
              value={selLanguage}
              change={(v) => { setLanguage(v.value); }}
            />
            <DropDownListComponent
              id="ddlbundle"
              key={selBundle || 'bundle-empty'}
              floatLabelType="Auto"
              cssClass="e-outline"
              dataSource={bundleData}
              fields={{ value: '_id', text: 'name' }}
              placeholder="Select AlertBundle"
              value={selBundle}
              change={(v) => { setBundle(v.value); }}
            />
          </div>
        </div>
      </div>
      <div className="mt-20" style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
        {associate && associate._id && associate._id === 'add_associate'
          ? <ButtonComponent id="edit" cssClass="e-icons e-plus" onClick={addProfile}>Add</ButtonComponent>
          : <ButtonComponent id="add" cssClass="e-icons e-save" onClick={saveProfile}>Save</ButtonComponent>}
        <ButtonComponent id="add" cssClass="e-icons e-close" onClick={closeDialog}>Cancel</ButtonComponent>
      </div>
    </div>
  );
};
export default AssociateContent;
